module.exports = __webpack_public_path__ + "assets/shuang.01f7079c.svg";